export default "__VITE_ASSET__B4kt3hkL__"